import { RadarChart } from '@opd/g2plot-react';
import useMediaQuery from 'hooks/useMediaQuery';



type ChartData = {
  item: string;
  value: number;
}

const StatisticsRadarChart = ({data}: {data: ChartData[]}) => {
  const isLessThan900px = useMediaQuery('(max-width:900px)');

  return (
    <RadarChart
      data={data}
      animation={false}
      xField="item"
      yField="value"
      area={{
        style: {
          fill: 'rgba(93, 156, 236, 0.3)', // Light blue fill
        },
      }}
      lineStyle={{
          lineWidth: 4, // width of the blue line
      }}
      meta={{
        value: {
          min: 0,
          max: 100,
          tickCount: 3,
        },
      }}
      xAxis={{
        line: null,
        label: {
          style: {
            fontSize: isLessThan900px ? 10 : 12,
            fill: '#555',
            fontFamily:'Poppins'
          },
        },
      }}
      yAxis={{
        label: false, // hide radial axis labels
        line: null,
        tickLine: null,
        grid: {
          line: {
            type: 'line',
            style: {
              stroke: '#d1d5db',
              lineDash: [4, 4],
            },
          },
        },
      }}
      tooltip={{
        showCrosshairs: false,
      }}
    />
  );
};

export default StatisticsRadarChart;
